"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _descriptionTable = require("./descriptionTable");

var _env = _interopRequireWildcard(require("./env"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * @File         : 判断端能力是否可以使用
 * @Author       : gaojiajun01
 * @Date         : 2022-08-10 21:48:39
 * @LastEditors  : gaojiajun01
 * @LastEditTime : 2022-09-04 00:37:28
*/
// name eg:  common.follow
var _default = function _default(name) {
  // 版本判断下
  if ((0, _env.versionCompare)(_env.default.sdkVersion, '6.4.0') < 0) {
    return true;
  }

  if (!(0, _includes.default)(name).call(name, '.')) {
    console.error('非法输入');
    return false;
  }

  try {
    var descTable = (0, _descriptionTable.getAllDescriptionTable)();

    var _name$split = name.split('.'),
        _name$split2 = (0, _slicedToArray2.default)(_name$split, 2),
        subModuleName = _name$split2[0],
        actionName = _name$split2[1];

    if (!descTable[subModuleName]) {
      return false;
    }

    if (!descTable[subModuleName][actionName]) {
      return false;
    }

    return true;
  } catch (_unused) {
    return false;
  }
};

exports.default = _default;